exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".class-page[data-v-52abbcea]{background:#fafafa!important;padding-top:40px}", ""]);

// exports
